import { CommonStateEnum, SourceTypeEnum } from './common';
import { ComplinEnum } from './inspection';
import { ChangeEnum, ConfirmedEnum, OperateEnum, OperateEnum2 } from './inventory';
import { InventoryStandard, Product } from './product';
import { PurchaseOrderItem } from './purchase';
import { RequirementItem } from './requirement';
import { SaleItemState } from './sales';
import { User } from './user';

export interface InventoryV2 {
  id: string;
  productId: string;   //
  count: number;        //库存量;not null
  preIn: number;        //预入库量;not null
  preOut: number;        //预出库量;not null
  lotCount: number;	      //批次数;not null
  product: Product;  //nullable
  standard: InventoryStandard | null;
}

export interface InventoryWithLPLParam {
  productId: string;
  lot: string;
  locationId: string;
}
export interface InventoryWithLPL {
  id: string;
  locationId: string;
  lotItemId: string;
  count: number;        //库存量;not null
  preIn: number;        //预入库量;not null
  preOut: number;        //预出库量;not null
  barcodes: Array<ItemBarcode> | null;
  lotItem: InventoryLotItem;
  location: WLocation;
}

// export enum LocationTypeEnum {
//   NORMAL = 1,
//   COMPLETE = 2,
//   WASTED = 3,
//   TEMP = 4,
//   OUTTER = 5,
//   PRODUCTION = 6,
//   DEFECTIVE_RETURN = 7,
//   DEFECTIVE_TEMP = 8,
// }
export interface AddLocation {
  l1: number;                 //索引1;nullable
  l2: number | null;		          //索引2;nullable
  l3: number | null;		          //索引3;nullable
  l4: number | null;		          //索引4;nullable
  l5: number | null;		          //索引5;nullable
  type: number;		  //LocationTypeEnum
  label1?: string;            //nullable
  label2?: string;            //nullable
  label3?: string;            //nullable
  label4?: string;            //nullable
  label5?: string;            //nullable
  desc?: string;                    //nullable
}

export interface UpdataOrderLot {
  lot?: string;
  thdLot?: string;
}

export interface OrderAddV2 {
  type: ChangeEnum;
  opType: OperateEnum;
  opType2?: OperateEnum2;
  returnOrderId?: string;
  desc: string;
  preTime: number | null;
  arrivalAt: number | null;
  items: Array<OrderAddItemV2>;
  sourceId?: string;
  sourceType?: SourceTypeEnum;
}
export interface OrderItemV2ExtAdd {
  originalBrand?: string;    //物料原厂名称
  originalCode?: string;     //物料原厂代码 
  manufactureDate?: number;  //物料原厂生产周期
  msdLevel?: string;         //物料MSD等级
  originPlace?: string;      //产地
  netWeight?: number;        //净重 
  netWeightDecimal?: number; //净重（支持小数）
  grossWeightDecimal?: number; //毛重（支持小数）
  dcc?: string; //保质期
}
export interface OrderAddItemV2 {
  sourceType?: SourceTypeEnum;
  sourceId?: string;
  productId: string;
  opType2?: OperateEnum2;
  count: number;
  lot: string;
  thdlot: string;
  desc: string;
  locations: Array<AddItemLocation>
  ext?: OrderItemV2ExtAdd;
}

export interface AddItemLocation {
  locationId: string;
  count: number;
  barcodes: Array<string>
}

export enum LocationLockEnum {
  UN_LOCKED = 0,
  LOCKED = 1,
}
export interface WLocation {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator: User;
  updater: User;
  number: string;            //库位编码
  l1: number;                 //索引1;nullable
  l2: number | null;		          //索引2;nullable
  l3: number | null;		          //索引3;nullable
  l4: number | null;		          //索引4;nullable
  l5: number | null;		          //索引5;nullable
  label1: string;            //nullable
  label2: string;            //nullable
  label3: string;            //nullable
  label4: string;            //nullable
  label5: string;            //nullable
  desc: string;                    //nullable
  lots: Array<InventoryLocationItem>;  //nullable
  lockState: LocationLockEnum;
  count: number | null;
  type: number;
}

export interface InventoryLocation {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  preIn: number;                          //not null
  preOut: number;
  count: number;
  location: WLocation;
  lotItemId: string;
  lotItem: InventoryLotItem;
  barcodes: Array<string> | null;
}

export interface ItemBarcode {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator: User;
  updater: User;
  lotItemLocationId: string;                  //not null
  barcode: string;                           //not null
  product: Product;                      //nullable
  lotItemLocation: InventoryLotItem            //nullable
}

export interface LocationLot {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator: User;
  updater: User;
  lot: string;
  sourceId: string;
  sourceType: SourceTypeEnum;
  thdLot?: string;
  desc: string;
  items: Array<InventoryLotItem>;
}

export interface InventoryLot {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator: User;
  updater: User;
  lot: string;    //批次号
  sourceId: string;
  sourceType: SourceTypeEnum;
  thdLot: string;
  desc: string;
  items: Array<InventoryLotItem>;
}

export interface InventoryLotItem {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator: User;
  updater: User;
  lotId: string;                            //not null
  lot: InventoryLot;
  productId: string;                         //not null
  count: number;                              //not null
  preIn: number;                          //not null
  preOut: number;                             //not null
  product: Product | null;                       //nullable
  locations: Array<InventoryLocation> | null;        //nullable
  ext?: OrderItemV2Ext | null;
  source: any;
  purchaseItem: PurchaseOrderItem | null;
  purchaseItemId: string | null;
}
export interface InventoryLocationItem {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator: User;
  updater: User;
  barcodes: Array<ItemBarcode> | null;
  count: number;                    //not null
  preIn: number;                     //not null
  preOut: number;                    //not null
  locationId: string;             //not null
  location: WLocation;         //nullable
  lotItemId: string;              //not null
  lotItem: InventoryLotItem;            //nullable
}

export interface OrderV2 {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  creator: User;
  updatedAt: number;
  updater: User;
  confirmer: User | null;
  updatedBy: string;
  number: string;
  type: ChangeEnum;
  opType: OperateEnum;
  opType2: OperateEnum2 | null;
  desc: string;
  printCount: number;
  logBookId: string;
  confirmState: ConfirmedEnum;
  confirmedAt: number;
  orderTime: number;
  preTime: number;
  arrivalAt: number;
  returnOrderId: string;
  items: Array<OrderItemV2>;
  docId: string;
  iqcState: QCStateEnum | null;
  sourceType: SourceTypeEnum | null;
  sourceId: string | null;
}


export interface OrderItemV2Ext {
  orderItemId: string;
  originalBrand: string;
  originalCode: string;
  brand?: string | null;
  mpn?: string | null;
  dcc?: string;
  manufactureDate: number;
  msdLevel: string;
  originPlace: string;
  netWeight: number;
  createdAt: number;
  updatedAt: number;
}

// OrderItemV2 基础字段（排除 sourceType 和 source）
interface OrderItemV2Base {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator: User;
  orderId: string;
  sourceId: string;
  productId: string;
  lot: string;
  thdLot: string;
  count: number;
  desc: string;
  order: OrderV2;
  product: Product;
  locations: Array<OrderItemLocation>;
  ext: OrderItemV2Ext | null;
  brand?: string | null;
  mpn?: string | null;
  dcc?: string | null;
  productNewCount: number | null;
  productOldCount: number | null;
  lotItemNewCount: number | null;
  lotItemOldCount: number | null;
  specialHandlingAggregate: SpecialHandlingStateEnum | null;        // 保管条件符合度(0/1/2)，可空(null=未检/不适用)
  lotItem: InventoryLotItem | null;
}

// 判别联合类型：根据 sourceType 自动推断 source 类型
export type OrderItemV2 =
  | (OrderItemV2Base & {
    sourceType: SourceTypeEnum.PURCHASE_ITEM;
    source: PurchaseOrderItem;
  })
  | (OrderItemV2Base & {
    sourceType: SourceTypeEnum.REQUIREMENT_ITEM;
    source: RequirementItem;
  })
  | (OrderItemV2Base & {
    sourceType: SourceTypeEnum.SALE_ITEM;
    source: SaleItemState;
  })
  | (OrderItemV2Base & {
    sourceType: SourceTypeEnum;
    source: null;
  });
//TODO

export enum SpecialHandlingStateEnum {
  REJECTED,
  RESOLVED,
  PENDING
};
export interface OrderItemSpecialData {
  id: string;
  locationId: string;
  lotItemLocationId: string;
  orderItemId: string;
  specialHandlingRemark: string;
  specialHandlingState: SpecialHandlingStateEnum | null;
};

export interface SpecialHandlingConfirm {
  locationId: string;
  state: SpecialHandlingStateEnum | null;
  remark: string;
};

export interface OrderItemLocation {
  id: string;
  locationId: string;
  orderItemId: string;
  count: number;
  barcodes: Array<ItemBarcode>;
  location: WLocation;
  orderItem: OrderItemV2;
}

//盘点
export interface CountItemBarcode {
  id: string;
  barcode: string;
  itemId: string;
  item: CountOrderItem | null;
}

export interface CountOrderItem {
  id: string;
  orderId: string;
  lotStr: string;
  productCode: string;
  productId: string;
  counting: number;
  barcodes: Array<CountItemBarcode>;
  order: OrderV2 | null;
  product: Product;
}
export enum CountOrderStateEnum {
  COUNTING = 0,
  DONE = 1,
}
export interface CountOrder {
  id: string;
  createdAt: number;
  updatedAt: number;
  creator: User;
  updater: User;
  orderState: CountOrderStateEnum;
  number: string;
  locationId: string;
  logBookId: string;
  desc: string;
  location: WLocation | null;
  items: Array<CountOrderItem>
}

export interface CountAddItem {
  lotStr: string;
  productCode: string;
  counting: string;
  barcodes: Array<string>;
}
export interface CountAddProps {
  locationId: string;
  desc: string;
  items: Array<CountAddItem>
}

/**
 * 1.locationBarcodd和countingBarcode值相等：盘点的条码和系统的条码都有的；
 * 
 * 2.locationBarcode为字符串，countingBarcode为null：盘点没有此条码，系统中存在；
 * 
 * 3.locationBarcode为null，countingBarcode为字符串：盘点有此条码，系统中不存在；
 * 
 */
export interface BarcodeDiff {
  locationBarcode: string | null;
  countingBarcode: string | null;
}
export interface CountRes {
  orderId: string;
  productId: string;
  productCode: string;
  productName: string;
  lotItemLocationId: string;
  lotStr: string;
  count: number;   //系统中的数量
  counting: number;   //盘点录入的数量
  barcodeDiffs: Array<BarcodeDiff>
}

//移库参数
export interface MoveLocationProps {
  lotStr: string;
  productCode: string;
  barcodes: Array<string>;
  count: number;
}

// 订单项数量更新请求DTO
export interface InventoryOrderItemCountUpdateReqDto {
  orderItemId: string;  // 订单项ID，非空
  count: number;        // 新的数量，非空
}

//库位出入库明细
export interface OrderItemLocationDtl {
  barcodes: ItemBarcode[] | null;
  count: number;
  createdAt: number;
  id: string;
  // location: WLocation;
  locationId: string;
  lotItemLocationId: string;
  lotItemLocationNewCount: number;
  lotItemLocationOldCount: number;
  lotItemNewCount: number;
  lotItemOldCount: number;
  orderItem: OrderItemV2;
  orderItemId: string;
  productNewCount: number;
  productOldCount: number;
  specialHandlingRemark: string;
  specialHandlingState: SpecialHandlingStateEnum | null;
}

//库位管理商品
export interface LocationRefProduct {
  id: string;
  state: CommonStateEnum;
  productId: string;
  locationId: string;
  desc: string | null;
  product: Product;
  location: WLocation;
}

export enum IQCResEnum {
  NOT_IQC,
  PASS,
  FAIL
}

export enum IQCDefectEnum {
  FRONT = 1,
  SIZE,
  POWER,
  PACKAGE,
  TAG,
  OTHER
}

export enum IQCDisposeEnum {
  RETURN = 1,
  ACCEPT,
  REDO,
}


export enum QCTypeEnum {
  INBOUND = 1,
  OUTBOUND,
  WAREHOUSE,
  PROCESS,
  RETURN
}

export enum QCStateEnum {
  QC_TODO,
  QC_ING,
  QC_PASS,
  QC_FAIL,
}
export interface QCItem {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator: User;
  updater: User;
  qcOrderId: string;
  lot: string;
  productId: string;
  checkCount: number;
  passCount: number;
  failCount: number;
  qcResult: IQCResEnum;
  defectType: IQCDefectEnum | null;
  disposition: IQCDisposeEnum | null;
  inspectorId: string;
  inspectedAt: number;
  remarks: string;
  docId: string;
  product: Product;
  inspector: User;
};
export interface IQCOrder {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator: User;
  updater: User;
  number: string;
  qcType: QCTypeEnum;
  qcState: QCStateEnum;
  sourceOrderId: string;
  inspectorId: string;
  inspectedAt: number | null;
  desc: string;
  items: Array<QCItem>;
  sourceOrder: OrderV2 | null;
  inspector: User | null;
};

export interface AddIQCItem {
  lot: string;
  productId: string;
  checkCount: number;
  passCount: number;
  failCount: number;
  qcResult: IQCResEnum | null;
  defectType: IQCDefectEnum | null;
  disposition: IQCDisposeEnum | null;
  inspectorId: string;
  remarks: string;
  docId: string;
};
export interface AddIQCOrder {
  qcType: QCTypeEnum;
  sourceOrderId: string;
  desc: string;
  items: Array<AddIQCItem>
}
